import React from "react";

export default function Android() {
  return (
    <svg
      className="android"
      style={{ position: "absolute", top: "290px" }}
      xmlns="http://www.w3.org/2000/svg"
      width="926"
      height="1000"
      viewBox="0 0 926 1176.459">
      <g transform="translate(-34 -360.068)">
        <g transform="translate(34.008 360.054)">
          <g transform="translate(-0.008 0.014)">
            <path
              d="M706.771,204.555c0,17.6-154.239,31.84-344.443,31.84S17.82,222.151,17.82,204.555s154.239-31.9,344.508-31.9S706.771,186.894,706.771,204.555Z"
              transform="translate(97.09 940.064)"
              fill="#412a62"
              fill-rule="evenodd"
            />
            <path
              d="M643.556,719.363c-5.672,32.227-9.99,63.487-21.4,93.2-2.063,5.414-6.445,11.537-5.285,16.114s8.508,6.445,12.891,9.732c22.688,16.565,35.514,40.413,46.923,65.034a356.113,356.113,0,0,1,30.745,129.618c0,2.127.387,4.318.387,6.445,0,13.406,1.418,25.4,16.887,31.2a33.192,33.192,0,0,1,15.147,17.274,238.021,238.021,0,0,1,16.951,42.347c3.223,10.57-.838,15.4-12.44,15.856-27.071.967-54.142,0-81.212-.645-21.657-.387-43.378-.967-65.034-1.483h-2.449c-15.985,0-17.854-2.9-13.922-18.241a98.1,98.1,0,0,1,46.794-64.454c3.223-1.8,5.479-3.674,5.156-7.992-2-34.547-6.9-68.579-21.334-100.548a169.9,169.9,0,0,0-38.674-52.92,7.09,7.09,0,0,0-11.086-.838,272.834,272.834,0,0,1-89.849,43.249,52.4,52.4,0,0,1-30.68.387,217.917,217.917,0,0,1-75.927-38.673c-8.444-6.445-8.444-6.445-16.436,1.289-26.233,25.782-40.284,57.558-47.761,92.75a436.109,436.109,0,0,0-7.026,51.563,10.7,10.7,0,0,0,5.865,12.182,98.486,98.486,0,0,1,46.794,67.032c2.578,11.666.709,14.567-11.408,14.953-20.11.58-40.219.838-60.329,1.16q-43.055.58-85.982,1.031c-18.885,0-23.075-5.672-15.92-22.946a340.944,340.944,0,0,1,14.116-33.838,52.4,52.4,0,0,1,25.782-25.008,7.219,7.219,0,0,0,5.35-7.219,778.4,778.4,0,0,1,9.024-77.345c9.152-45.118,24.235-87.529,52.981-124.268a83.8,83.8,0,0,1,21.334-19.336,7.412,7.412,0,0,0,3.738-10.313A529.125,529.125,0,0,1,287.253,756.3c-2-11.666-4-23.2-6.446-36.417-9.926,8.121-19.336,15.6-28.3,23.01a463.423,463.423,0,0,0-74.574,79.472A26.3,26.3,0,0,0,172,840.154a115.373,115.373,0,0,1-15.791,62.134c-7.67,13.471-14.567,27.329-22.366,40.735-5.092,8.9-8.186,9.6-16.887,4.963S99.3,937.927,90.732,932.513s-8.766-7.606-4.512-16.565c5.994-12.891,12.375-25.459,18.047-38.35,2.643-6.445,3.932-12.891,5.994-19.336,1.547-4.834-.645-5.221-4.834-4.641a50.467,50.467,0,0,0-27.006,12.891,270.705,270.705,0,0,0-25.782,26.62c-8.379,9.668-10.377,10.119-20.819,3.416C22.8,890.748,14.1,884.5,5.265,878.436a9.217,9.217,0,0,1-3.48-13.793C23.7,832.416,48.9,804.121,88.476,793.292a111.105,111.105,0,0,1,18.885-3.674,16.113,16.113,0,0,0,13.729-9.346,358.1,358.1,0,0,1,75.476-97.133A351.784,351.784,0,0,1,269.4,633.574c5.414-2.771,9.217-5.607,9.281-12.311,0-8.444,4.963-11.086,12.891-11.151,28.682,0,57.364-.967,86.046-1.031,6.445,0,8.83-2,8.25-8.637a175.571,175.571,0,0,1,0-22.559c0-4.189-.838-5.092-5.35-4.963-45.118,1.031-90.236,1.547-135.032,2.578-6.445,0-8.637-1.74-8.7-7.734,0-14.438-.709-28.94-.838-43.378q-.967-132.26-1.869-264.263c0-34.032-1.289-68.064-.838-102.16,0-21.334-1.676-17.209,17.4-17.789q49.372-1.418,98.808-2.385c4.061,0,5.672-.967,5.736-5.285,0-7.219,1.1-14.438,1.74-21.592a21.657,21.657,0,0,1,6.445-15.082c4.641-4.19,3.609-10.957,4.641-16.565A94.1,94.1,0,0,1,448.969,1.02,96.23,96.23,0,0,1,547,49.619a87.786,87.786,0,0,1,9.733,30.358A27.2,27.2,0,0,0,560.8,93.706c9.153,10.055,7.348,22.366,8.444,34.032.58,5.93,2.32,7.541,8.186,7.477h93.33c6.445,0,8.121,1.547,7.992,7.992-.967,68.322-1.547,136.643-2.32,205.029q-.516,45.827-1.031,91.654c-.451,41.831-1.031,83.791-1.16,125.428,0,5.994-2.449,6.445-7.026,6.445-43.184,0-86.3.451-129.489.451-5.221,0-7.863.709-7.477,6.445a130.124,130.124,0,0,1-.387,20.045c-.645,7.025,2.965,8.637,8.895,8.637h97.326c7.283,0,10.635,3.158,10.313,9.99a16.951,16.951,0,0,0,11.086,16.951A326.073,326.073,0,0,1,801.211,775.438a25.782,25.782,0,0,0,20.561,14.953c35.45,2.707,59.749,24.042,82.63,48.018a151.667,151.667,0,0,1,19.336,25.782,9.41,9.41,0,0,1-2.9,14.5c-9.024,6.445-17.854,12.891-27.006,18.821s-12.891,5.672-20.045-3.738a103.965,103.965,0,0,0-39.833-35.256,141.82,141.82,0,0,0-13.6-4.77c-4.318-1.354-5.672,0-4.641,4.641a148.239,148.239,0,0,0,11.473,31.583c3.932,8.186,7.992,16.307,11.924,24.493,5.092,10.442,4.576,12.891-4.963,19.336-8.315,5.285-17.08,9.99-25.782,14.953a9.539,9.539,0,0,1-14.115-2.449c-21.334-30.294-39.188-62.134-39.833-100.484a42.41,42.41,0,0,0-8.9-26.684,458.073,458.073,0,0,0-97.39-96.23Z"
              transform="translate(0.008 -0.014)"
              fill="#010101"
              fill-rule="evenodd"
            />
            <path
              d="M63.885,266.356a493.592,493.592,0,0,1-18.3-157.075c0-9.41,4.77-10.248,11.86-10.377,33.452-.645,66.968-1.74,100.42-2,56.784-.451,113.633-.516,170.417-.516,17.467,0,34.87.58,52.272.9,3.932,0,7.025.451,7.154,6.059A518.213,518.213,0,0,1,370.171,263.2c-1.869,6.445-4.447,12.891-6.446,18.885a324.721,324.721,0,0,1-91.267,92.685A107.961,107.961,0,0,1,194.4,392.944a62.261,62.261,0,0,1-28.747-13.793,396.972,396.972,0,0,1-92.1-94.551C69.686,278.86,67.816,272.092,63.885,266.356Z"
              transform="translate(245.549 524.795)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M448.628,23.13c5.479,0,8.379.709,8.186,7.219-.516,24.879-.58,49.823-.9,74.7-.58,36.932-1.483,73.929-1.74,110.926-.387,51.563,0,103.127-.58,155.206,0,17.918-.645,35.9-.451,53.884,0,5.543-2.062,6.445-6.961,6.445-29.2,0-58.46.451-87.658.709L52.17,435.186c-7.477,0-10.119-1.418-10.055-9.475,0-33.258-.58-66.517-.645-99.711,0-87.658-.709-175.316-2.643-262.973,0-9.6,0-19.336-.58-28.876-.387-6.445,2.643-6.832,7.606-6.9,27.264-.58,54.593-1.74,81.921-2H247.531S381.6,23.13,448.628,23.13Z"
              transform="translate(208.149 125.864)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M163.756,227.591H98.592c-4.9,0-6.445-.773-5.35-6.445a85.273,85.273,0,0,1,36.417-50.21A29.777,29.777,0,0,1,149,165.973c14.18.967,28.424,1.482,42.411,3.416a40.864,40.864,0,0,1,33.258,25.782c3.738,8.637,6.445,17.6,10.119,26.233,2.063,4.77.967,5.865-4.061,5.865Q197.078,227.559,163.756,227.591Z"
              transform="translate(505.977 903.04)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M28.83,226.687c5.092-12.891,9.539-25.008,15.211-36.481A36.546,36.546,0,0,1,74.27,169.065c15.92-1.74,32.227-2.256,48.018-3.094A21.4,21.4,0,0,1,134.4,169.58a81.212,81.212,0,0,1,37.319,51.886c.838,3.481.387,5.35-4.061,5.285Z"
              transform="translate(157.044 903.687)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M92.654,228.324a431.133,431.133,0,0,0,17.016-52.079c2.514-10.957.516-13.987-10.313-15.6a47.052,47.052,0,0,0-29.971-.967,94.62,94.62,0,0,0-50.21,33.71c-1.74,2.256-2.643,6.445-7.09,4.383C.1,189.973.1,189.973,8.864,178.887,28.2,154.266,50.952,133.769,82.6,126.357a56.075,56.075,0,0,1,30.938.773c23.655,7.412,32.678,22.3,30.036,46.858-2.707,25.782-14.5,47.245-26.362,69.1-9.862,0-17.016-6.445-24.622-11.344C91.752,231.353,91.881,229.613,92.654,228.324Z"
              transform="translate(14.457 678.136)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M156.1,161.033a13.858,13.858,0,0,0-4.447,13.664c2.449,22.495,12.44,42.282,22.559,61.876,3.094,6.059,2.578,9.152-3.867,11.022-3.867,2.063-5.994-.838-8.25-2.965a95.654,95.654,0,0,1-23.01-29.327,209.352,209.352,0,0,1-19.336-59.1,13.665,13.665,0,0,1,0-7.025c9.41-18.627,34.1-28.553,56.591-23.075,35.643,8.572,60.909,31.067,81.47,60.007,2,2.836,1.934,4.641-1.031,6.445s-5.35,3.416-8.057,5.156c-4.254-.9-6.445-4.576-9.281-7.283-10.184-9.41-18.821-20.561-31-27.844a66.322,66.322,0,0,0-35.192-9.41,20.948,20.948,0,0,0-17.145,7.864Z"
              transform="translate(649.631 678.395)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M48,122.76c7.412,6.445,10.184,16.049,15.727,23.784a395.3,395.3,0,0,0,89.462,89.14c25.073,18.434,51.563,14.373,79.472,4.9,21.27-7.283,37.706-21.141,53.755-35.514a434.6,434.6,0,0,0,50.855-53.561c3.416-4.383,5.027-10.184,10.377-12.891A179.7,179.7,0,0,1,271.4,234.653a228.558,228.558,0,0,1-66.517,27.457,35.9,35.9,0,0,1-19.336-.322c-69.417-20.5-116.018-64.454-136.965-134.194A17.139,17.139,0,0,0,48,122.76Z"
              transform="translate(261.433 668.391)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M188.939,84.472c8.121-23.461,7.219-44.731-14.631-59.685a49.952,49.952,0,0,0-55.431-2.836C94,35.874,91.614,58.755,97.414,84.472H64.027c-5.221,0-5.285-1.934-4.9-6.445,5.479-66.9,72-90.236,119.111-67.548C207.307,24.594,220.2,48.829,223.42,79.7c0,3.223,0,4.963-4.125,4.834C209.436,84.343,199.574,84.472,188.939,84.472Z"
              transform="translate(321.269 11.089)"
              fill="#fefefe"
              fill-rule="evenodd"
            />
            <path
              d="M150.258,42.886H65.049c-5.8,0-7.863-1.225-7.734-7.477,0-18.369,0-18.369,18.112-18.369h158.3c6.445,0,9.475,1.676,8.766,8.379-.58,5.608,3.8,12.891,0,16.178s-11.215,1.225-17.08,1.289C200.6,42.951,175.4,42.886,150.258,42.886Z"
              transform="translate(312.125 92.701)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M99.632,36c-4.641-1.8-8.766-9.088-12.891-4.318s2.836,9.088,6.445,12.891a19.336,19.336,0,0,1,5.8,9.346c2,8.9,0,11.537-9.088,11.6H87.515c-19.336,0-21.786-2.707-21.463-22.366,0-21.657,15.791-36.61,38.673-37.383a38.673,38.673,0,0,1,41.766,34.483,21.141,21.141,0,0,1-22.624,25.008,53.752,53.752,0,0,1-6.445,0c-2.643-.322-6.445,1.611-7.477-2.514a9.539,9.539,0,0,1,2.514-11.022c4.383-3.481,8.83-6.9,13.213-10.442,2.063-1.676,4.705-3.481,2.643-6.445s-5.221-1.1-7.734,0a38.993,38.993,0,0,0-4.061,2.578c-3.481,2.514-5.221,1.74-5.479-2.643s1.225-9.475-4.125-9.668-4.9,5.479-6.445,9.153A11.8,11.8,0,0,1,99.632,36Z"
              transform="translate(359.592 30.556)"
              fill="#e0bb30"
              fill-rule="evenodd"
            />
            <path
              d="M63.84,123.65c-3.481-10.377-.644-21.012-1.16-31.518,0-3.158,2.836-3.352,5.35-3.352H169.223c6.445,0,9.668,2.449,8.83,9.41a106.561,106.561,0,0,0,0,12.891,16.822,16.822,0,0,1-12.246,2.449H81.694C73.121,113.466,65.9,113.659,63.84,123.65Z"
              transform="translate(338.085 483.356)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M160.343,167.51c0,2.32-2,2.643-3.609,3.352-12.891,5.736-26.491,11.344-39.7,17.209-3.481,1.611-5.285.322-7.219-2.449-5.027-7.283-10.119-14.5-15.534-21.463-2.449-3.094-2.127-4.641,1.16-6.832a172.415,172.415,0,0,1,44.216-20.5c2.514-.773,4.447-.9,5.93,2,4.512,9.088,9.281,18.047,13.986,27.006Z"
              transform="translate(504.684 742.43)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M58.946,136.443c4.576,1.482,9.153,2.9,13.664,4.576a224.9,224.9,0,0,1,32.227,16.436c3.8,2.062,3.223,3.738,1.1,6.445-5.35,7.348-10.57,14.825-15.469,22.43a4.447,4.447,0,0,1-6.445,1.869c-12.891-5.865-26.426-11.6-39.7-17.338-2.9-1.225-4.318-2.385-2.385-5.865,4.576-8.443,8.766-17.145,12.891-25.782C55.6,137.861,56.3,135.8,58.946,136.443Z"
              transform="translate(223.545 742.237)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M54.237,164.786c-8.057-6.445-16.049-12.891-24.17-19.336-2.707-2.127-2.836-3.674,0-6.445,10.7-10.055,21.334-20.174,31.776-30.487a7.67,7.67,0,0,1,9.99-1.418,51.562,51.562,0,0,1,21.592,21.786,3.609,3.609,0,0,1-1.031,4.963c-11.086,10.377-22.946,19.981-34.225,30.165A4.061,4.061,0,0,1,54.237,164.786Z"
              transform="translate(152.456 576.349)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M139.358,144.127c3.545-.773,5.543,1.482,6.445,5.8,2.449,9.024,5.156,17.983,8.186,26.877,1.483,4.512,0,6.445-4.254,7.154-12.891,2.449-25.782,4.9-38.673,7.67-3.545.773-4.9-.58-5.93-3.481-1.8-5.027-3.738-10.055-5.543-15.018-4.125-11.6-4.061-11.473,6.445-17.983a70.192,70.192,0,0,1,33.323-11.022Z"
              transform="translate(528.505 783.925)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M81.513,191.237c-12.891-2.385-25.782-5.027-38.673-7.412-4.318-.838-5.736-2.449-4.125-6.961,2.772-7.992,5.35-16.178,7.541-24.428a9.539,9.539,0,0,1,12.891-7.863,99.067,99.067,0,0,1,33.581,14.373c2.965,1.8,4.254,3.545,2.9,7.025-2.9,7.477-5.608,15.018-8.25,22.559C86.411,191.3,84.929,192.591,81.513,191.237Z"
              transform="translate(207.36 783.738)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M83.013,147.962A17.6,17.6,0,0,1,79.146,161.5c-6.445,7.219-10.828,7.154-16.694,0-8.186-10.184-16.307-20.5-24.686-30.551-2.514-3.029-2.385-4.512,1.1-6.445,12.891-7.541,25.073-15.34,37.577-23.139,3.8-2.385,4.963-1.16,5.092,2.965a417.377,417.377,0,0,0,1.482,43.636Z"
              transform="translate(196.32 545.284)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M105.868,127.443c5.156-8.637,11.6-17.854,20.3-20.948,10.184-3.609,15.469,8.572,22.495,14.309s12.5,12.375,18.821,18.5c2.771,2.578,3.094,4.383,0,6.832-5.93,4.512-11.666,9.217-17.532,13.858-7.735,0-12.891-6.445-18.434-9.926a194.015,194.015,0,0,1-23.075-18.112C106.9,130.859,105.159,129.7,105.868,127.443Z"
              transform="translate(575.66 576.244)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M69.867,189.742c-9.346-.58-18.627-1.225-27.973-1.482-4.318,0-5.672-2.063-5.156-5.994s.58-5.865,1.1-8.766c4.834-25.782,0-20.561,25.073-20.883a24.233,24.233,0,0,1,4.77.644c21.914,4.834,25.782,11.86,17.854,33.065a4.576,4.576,0,0,1-5.221,3.545H69.867Z"
              transform="translate(199.54 829.707)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M122.251,189.818c-19.336.516-18.627,0-22.366-17.08-2-9.6,2.127-12.891,9.281-15.92a83.018,83.018,0,0,1,34.612-4.125c2.385,0,3.094,1.354,3.416,3.48,1.354,9.217,2.9,18.434,4.447,27.651.645,3.674-1.1,4.447-4.383,4.576C138.171,188.851,129.147,189.431,122.251,189.818Z"
              transform="translate(541.23 829.437)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M100.29,135.855V107.108c0-5.672,1.482-8.057,7.477-5.672a139.223,139.223,0,0,1,36.352,21.334c3.094,2.449,2.965,4.512.709,7.283-5.93,7.219-11.731,14.5-17.6,21.785a66.84,66.84,0,0,1-26.942-15.985Z"
              transform="translate(546.175 547.271)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M62.506,104.919a39.07,39.07,0,0,0,0-4.77c-.838-5.736,1.1-7.992,7.348-7.928,35.579.387,70.9,0,106.607,0,0,12.891,0,12.891-12.375,12.891Z"
              transform="translate(339.419 502.087)"
              fill="#853ded"
              fill-rule="evenodd"
            />
            <path
              d="M125,138.653c1.547-9.346,9.346-9.41,15.985-9.8A63.036,63.036,0,0,1,186.1,143.68a237.33,237.33,0,0,1,31.712,31.647,1.914,1.914,0,0,1-.838,1.289c-10.764,8.637-10.7,8.637-20.561-1.16a189.561,189.561,0,0,0-29.2-25.782A64.454,64.454,0,0,0,125,138.653Z"
              transform="translate(680.731 700.774)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M165.3,139.866c.709,3.545-1.354,4.254-2.772,5.285-9.346,6.445-18.756,12.375-28.038,18.821-2.9,2-4.576,1.483-6.445-1.289s-4.641-5.865-7.025-8.766c-7.477-9.281-7.606-9.346.645-18.176a61.232,61.232,0,0,1,26.491-15.985c1.611-.516,3.545-1.482,4.512,0C157.18,126.589,161.434,133.679,165.3,139.866Z"
              transform="translate(628.699 647.74)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M53.94,164.932l-2.514-1.611C42.08,156.875,32.8,150.43,23.389,144.629c-3.158-2.063-3.8-3.867-1.547-7.025a88.814,88.814,0,0,0,5.35-8.959c6.9-11.6,6.832-11.473,19.336-5.865a55.494,55.494,0,0,1,21.786,17.274c1.1,1.418,3.287,3.029,2.32,4.77a109.055,109.055,0,0,1-14.7,19.659S54.713,164.739,53.94,164.932Z"
              transform="translate(111.696 648.327)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M148.24,151.35c0,2.514-2,2.707-3.223,3.352-15.082,7.541-30.229,14.825-45.118,22.495-4.641,2.385-6.059-1.289-8.572-3.287s-1.1-4.512.516-6.768c7.863-10.764,15.791-21.463,23.526-32.227a7.09,7.09,0,0,1,10.893-2.32,75.476,75.476,0,0,1,19.336,15.34,12.176,12.176,0,0,0,2.642,3.415Z"
              transform="translate(489.91 713.022)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M48.772,158.679c-7.348-4.9-14.7-9.861-22.108-14.567-3.094-2-4-3.738-1.547-6.961,5.414-7.025,10.764-14.051,15.662-21.4,2.514-3.8,4.19-3.545,7.348-.773,7.026,6.445,14.373,11.989,21.592,17.983.387.387.967.967.773,1.289a56.526,56.526,0,0,1-21.721,24.428Z"
              transform="translate(129.175 614.683)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M59.74,185.357H51.747c-4.705-.322-11.666,2.32-13.664-1.225-3.223-5.865-1.1-13.535-1.031-20.432,0-2.578,2.32-2.449,4.125-2.707a108.994,108.994,0,0,1,39.833,1.869c2.965.58,4.125,2.062,3.8,4.963-.516,4.77-1.16,9.539-1.482,14.309,0,3.738-2.772,3.223-5.092,3.223Z"
              transform="translate(197.743 871.023)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M4.14,172.345c6.445-6.445,12.891-13.407,19.336-19.916a90.236,90.236,0,0,1,51.886-22.881,18.434,18.434,0,0,1,16.114,5.414A74.187,74.187,0,0,0,41.91,156.489c-5.027,4.834-9.99,9.668-14.889,14.567C16.128,181.561,16.451,181.626,4.14,172.345Z"
              transform="translate(22.597 704.144)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M113.458,109.19a327.755,327.755,0,0,0,43.893,32.227l-15.4,13.793a4.9,4.9,0,0,1-7.541-.387c-8.315-7.477-16.629-14.953-25.266-21.979-5.479-4.318-6.445-8.443-2.127-14.051C109.4,115.958,110.364,111.9,113.458,109.19Z"
              transform="translate(568.07 594.497)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M121.705,128.41a209.863,209.863,0,0,0,28.231,77.99,54.528,54.528,0,0,0,21.915,20.432c-19.336,11.473-14.5,12.053-25.782-5.414a150.114,150.114,0,0,1-26.813-76.765,31.841,31.841,0,0,1,2.449-16.243Z"
              transform="translate(648.382 699.158)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M123.788,185.549a70.505,70.505,0,0,0-10.442,0c-8.508,1.225-11.86-1.547-12.891-10.764-.773-8.25,1.1-11.6,9.024-12.891A96.037,96.037,0,0,1,143,161.057c1.547,0,3.609,0,3.674,2.256v20.045c0,2.643-2.707,2.127-4.447,2.191Z"
              transform="translate(546.202 871.025)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M67.573,131.191c2.127,0,3.223,1.74,4.318,3.223L98.06,169.8c1.354,1.8,2.643,3.287.645,5.543s-3.609,1.74-5.672.709L47.915,153.3c-1.225-.645-2.965-.9-2.578-3.287C46.045,145.757,62.8,131.062,67.573,131.191Z"
              transform="translate(246.63 714.295)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M151.7,142.071c-5.93,4.125-11.924,8.121-17.66,12.44a4.19,4.19,0,0,1-6.445-.709c-4.9-5.672-9.861-11.28-15.082-16.629-2.707-2.772-1.611-4.447.58-6.445A168.337,168.337,0,0,1,130.816,115,87.078,87.078,0,0,1,151.7,142.071Z"
              transform="translate(604.015 626.135)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M32.06,145.331c12.891-11.022,25.266-21.979,37.835-33.065.709-.645.838-1.869,1.225-2.836a4.7,4.7,0,0,1,1.16,1.1c8.83,14.824,8.895,14.824-3.932,26.362-4.963,4.447-9.99,8.766-15.147,12.891-8.7,7.09-8.7,7.09-17.209-.58a24.6,24.6,0,0,1-3.932-3.872Z"
              transform="translate(174.633 595.804)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M134.829,151.285c-2.256,0-3.223-1.676-4-3.416-4.125-9.024-12.44-15.082-16.823-23.913,17.918-14.76,17.918-14.76,31.518,3.674,8.186,11.086,8.186,11.086-3.352,18.95C139.727,148.192,137.278,150,134.829,151.285Z"
              transform="translate(620.886 616.92)"
              fill="#6529bc"
              fill-rule="evenodd"
            />
            <path
              d="M27.6,141.782A148.572,148.572,0,0,0,48.548,116c4.447,3.674,11.279,6.445,12.891,11.28s-5.865,8.444-9.41,12.44C39.653,153.512,43.907,153.706,27.6,141.782Z"
              transform="translate(150.347 631.58)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M101.521,106l27.071,15.985a61.7,61.7,0,0,1-4.125,5.736c-2.836,3.223-4.512,9.6-9.41,8.25A18.627,18.627,0,0,1,100.683,122.5a34.8,34.8,0,0,1,.838-16.5Z"
              transform="translate(544.944 577.126)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M22.009,140.65c.838,4.641,5.285,4.834,8.379,6.445,5.35,3.029,10.893,5.672,16.371,8.443-7.8,14.5-7.8,14.5-21.657,7.09-11.408-6.059-11.408-6.059-5.865-17.4C20.075,143.744,21.042,142.2,22.009,140.65Z"
              transform="translate(85.103 765.81)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M83.958,141.72a73.474,73.474,0,0,1,.387-13.6,27.458,27.458,0,0,1,20.561-23.268,29.069,29.069,0,0,1,30.229,11.989,32.227,32.227,0,0,1-1.031,33.516c-.9,1.225-2.449,2.127-2.32,3.932a11.859,11.859,0,0,1-8.057,6.768,34.418,34.418,0,0,1-35.385-8.186,13.664,13.664,0,0,1-4.383-11.151Z"
              transform="translate(456.415 567.188)"
              fill="#020102"
              fill-rule="evenodd"
            />
            <path
              d="M53.584,143.365a43.958,43.958,0,0,1,2.256-22.688,26.62,26.62,0,0,1,32.936-15.211,27.329,27.329,0,0,1,19.336,32.227c-.387,2.385-1.031,4.705-1.547,7.025-3.932,12.891-12.311,18.821-27.2,18.3A25.782,25.782,0,0,1,53.584,143.365Z"
              transform="translate(288.657 566.961)"
              fill="#020102"
              fill-rule="evenodd"
            />
            <path
              d="M68.108,132.266c1.934-11.86,6.445-22.688,18.5-26.813a28.424,28.424,0,0,1,28.875,7.09c9.8,8.9,10.7,23.075,2.772,39.059a25.782,25.782,0,0,1-33.645,9.475C71.009,155.727,66.239,147.412,68.108,132.266Z"
              transform="translate(368.815 566.781)"
              fill="#020103"
              fill-rule="evenodd"
            />
            <path
              d="M54.473,110.22a29.907,29.907,0,0,0,29.52,17.918,25.782,25.782,0,0,0,23.461-16.371c1.8,18.821-6.445,25.137-19.852,28.424-15.662,3.8-35.514-10.957-34.741-25.782a4.963,4.963,0,0,1,1.611-4.189Z"
              transform="translate(287.767 600.106)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M70.109,108.47a25.137,25.137,0,0,0,16.114,26.619,28.166,28.166,0,0,0,34.032-7.283,25.073,25.073,0,0,1-30.68,20.045C72.623,143.4,64.308,130.32,68.369,114.4,68.82,112.4,68.24,110.017,70.109,108.47Z"
              transform="translate(366.815 590.576)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M85.581,110c10.055,20.5,28.424,25.331,47.825,12.891,1.547,9.024-5.93,11.86-11.344,15.6a27.006,27.006,0,0,1-27.135-1.547C83.518,126.565,81.2,119.99,85.581,110Z"
              transform="translate(454.792 598.908)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M45.4,195.161V38.344c0-5.994,1.418-7.541,7.477-7.541,64.454,0,128.908.322,193.749,0,37.77-.322,75.54-1.031,113.311-1.482,8.572,0,10.377,2.9,10.506,10.248.516,34.805,1.547,69.611,2,104.48q.9,66.323,1.031,132.647c0,23.848-.967,47.7-.838,71.544,0,7.219-2.643,8.508-9.088,8.895-34.547,1.869-69.159,0-103.707.709-68.579,1.354-137.159,2.127-205.8,1.611-7.219,0-8.7-1.934-8.7-8.83C45.533,298.61,45.4,246.918,45.4,195.161Z"
              transform="translate(246.948 159.571)"
              fill="#010101"
              fill-rule="evenodd"
            />
            <path
              d="M114.361,120.926a14.18,14.18,0,0,1-13.535,15.6,13.922,13.922,0,0,1-14.953-14.18,16.5,16.5,0,0,1,14.76-16.114,14.438,14.438,0,0,1,13.729,14.7Z"
              transform="translate(467.649 578.378)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M69.535,106.23a14.824,14.824,0,0,1,14.244,15.34,14.051,14.051,0,0,1-13.471,14.953A13.858,13.858,0,0,1,55.1,122.537,15.856,15.856,0,0,1,69.535,106.23Z"
              transform="translate(300.034 578.378)"
              fill="#6229b5"
              fill-rule="evenodd"
            />
            <path
              d="M98.553,121.119a14.372,14.372,0,0,1-28.684,1.869A16.307,16.307,0,0,1,83.986,106.23a14.567,14.567,0,0,1,14.567,14.889Z"
              transform="translate(380.459 578.378)"
              fill="#e0bb30"
              fill-rule="evenodd"
            />
            <path
              d="M346.884,35.23c.709,38.673,1.8,77.345,2,116.018V308.774c0,10.957,0,11.151-10.957,11.86-32.614,2.127-65.292,2.643-97.97,2.772H71.084c-21.528,0-21.657,0-21.786-21.4Q48.4,172.131,47.687,42.32c-.967-9.475-.967-9.475,7.735-8.444a79.031,79.031,0,0,0,8.766.709H332.124C337.022,34.2,342.05,31.492,346.884,35.23Z"
              transform="translate(258.427 177.118)"
              fill="#e0bb30"
              fill-rule="evenodd"
            />
            <path
              d="M347.666,44.011c-49.952,3.223-99.969.9-149.985,1.418-42.024.451-83.791,0-126.073,0a58.009,58.009,0,0,1-22.366-2.256c-.322,2.836-.645,5.156-.9,7.477-2.449-4.834-.387-9.99-.773-14.953a3.481,3.481,0,0,1,3.932-4H336.387C348.246,31.635,348.246,31.635,347.666,44.011Z"
              transform="translate(256.645 172.338)"
              fill="#a78a1d"
              fill-rule="evenodd"
            />
            <path
              d="M140.655,62.182a8.959,8.959,0,0,1-2.9,5.608c-9.41,9.153-18.434,18.563-28.1,27.458-7.348,6.832-11.022,6.445-18.434-.645S75.17,78.231,67.177,69.917c-2.772-2.9-4.77-6.445-1.354-9.8a6.961,6.961,0,0,1,10.7,0C83.355,66.562,89.994,73.008,96.375,79.9c3.416,3.609,5.736,4.318,9.539,0,6.832-7.477,14.309-14.373,21.721-21.334a8.057,8.057,0,0,1,9.6-1.74,6.446,6.446,0,0,1,3.42,5.352Z"
              transform="translate(553.344 460.708) rotate(180)"
              fill="#020202"
              fill-rule="evenodd"
            />
            <path transform="translate(346 308.933)" fill="#010101" />
            <rect width="42" height="8" transform="translate(522 347.698) rotate(-45)" fill="#010101" />
            <rect width="42" height="8" transform="translate(527.657 318) rotate(45)" fill="#010101" />
            <g transform="translate(-174)">
              <rect width="42" height="8" transform="translate(522 347.698) rotate(-45)" fill="#010101" />
              <rect width="42" height="8" transform="translate(527.657 318) rotate(45)" fill="#010101" />
            </g>
          </g>
        </g>
        <circle cx="7" cy="7" r="7" transform="translate(736 577)" fill="#2d1d43" />
        <circle cx="11.5" cy="11.5" r="11.5" transform="translate(750 554)" fill="#2d1d43" />
        <circle cx="16.5" cy="16.5" r="16.5" transform="translate(773 521)" fill="#2d1d43" />
      </g>
    </svg>
  );
}
